export enum DefaultRolesFieldNames {
  Name = "Name",
  Region = "Region",
  FunctionalArea = "FunctionalArea",
}
